// extracted by mini-css-extract-plugin
module.exports = {"headingXl":"utils_headingXl__BC_Cj","headingMd":"utils_headingMd__2Vdrf","queryGrid":"utils_queryGrid__2lW5w","queryGridElement":"utils_queryGridElement__1OE-e"};